/*
export const someAction = (state) => {
}
*/
import Vue from 'vue';
import DataDB from '../others/data.js';
import users from '../others/users.js';
import utils from '../others/utils.js';
import router from '../router';
import { Dialog, Notify } from 'quasar';
import { search } from '../others/search.js';
import ErrorExt from '../others/error-ext.js';

let dataDB;
export default {
  destroyDataDB() {
    console.log('destroyDataDB');
    if (dataDB && typeof dataDB.destroy === 'function') {
      return dataDB.destroy();
    }
    return Promise.resolve(true);
  },
  doQuickSearch(context, query) {
    console.log('doQuickSearch', query);
    const _term = utils.normalizeStr(query.term);
    context.commit('setSearchQuery', { where: query.where, term: _term });
    return new Promise((resolve, reject) => {
      search(query.where, _term)
        .then((res) => {
          const total = res.length;
          context.commit('setResults', { results: res, term: _term, where: query.where });
          const toast = {
            error: `Поиск "${_term}"`,
            message: total === 0 ? 'Ничего не найдено' : `Всего найдено: ${total}`,
            type: total === 0 ? 'warning' : 'positive',
          };
          context.commit('pushError', toast);
          if (total === 0) {
            resolve(false);
          } else {
            resolve(true);
          }
        })
        .catch((err) => {
          console.log('doQuickSearch error', err);
          context.commit('pushError', {
            error: 'Ошибка',
            message: 'Внутренняя ошибка сервера',
          });
          reject(err);
        });
    });
  },
  hideSyncing(context) {
    setTimeout(() => {
      context.commit('setSyncing', '');
    }, 900);
  },
  processMedias(context) {
    context.dispatch('pleaseThumbate');
    dataDB.allDocs({
      include_docs: true,
      startkey: 'x', // to include only medias,
    })
      .then((result) => {
        result.rows.forEach((row) => {
          console.log('processMedias result', row.doc);
          if (row.doc) {
            if (!row.doc.dnd) {
              dataDB.remove(row.doc);
            } else if (!row.doc.saved) { // set flag "saved"
              const doc = Object.assign({}, row.doc, { saved: true });
              dataDB.put(doc);
            }
          }
        });
      })
      .catch((err) => {
        console.log('processMedias error', err);
      });
  },
  getAttachment(context, mediaId) {
    return new Promise((resolve, reject) => {
      utils.no401(dataDB, dataDB.getAttachment, mediaId)
        .then((blob) => {
          resolve(blob);
        })
        .catch((err) => {
          console.log('STORE getAttachment error', err);
          if (err.status === 404) {
            context.commit('pushError', {
              error: 'Ошибка!',
              message: 'Вложение не найдено',
            });
          } else {
            context.commit('pushError', {
              error: 'Ошибка!',
              message: 'Невозможно загрузить вложение',
            });
          }
          reject(err);
        });
    });
  },
  getThumb(context, mediaId) {
    return new Promise((resolve, reject) => {
      utils.no401(dataDB, dataDB.getThumb, mediaId)
        .then((blob) => {
          resolve(blob);
        })
        .catch((err) => {
          if (err.status === 404) {
            context.commit('pushError', {
              error: 'Ошибка!',
              message: 'Вложение не найдено',
            });
          } else {
            context.commit('pushError', {
              error: 'Ошибка!',
              message: 'Невозможно загрузить вложение',
            });
          }
          reject(err);
        });
    });
  },
  /* getThumb(context, mediaId) {
    return new Promise((resolve, reject) => {
      dataDB.getThumb(mediaId)
        .then((blob) => {
          resolve(blob);
        })
        .catch((err) => {
          console.log('STORE getThumb error', err);
          if (err.status === 401) {
            context.dispatch('waitRefresh')
              .then((refresh) => {
                console.log('STORE getThumb refresh', refresh);
                if (refresh) {
                  dataDB.getThumb(mediaId)
                    .then((blob) => {
                      resolve(blob);
                    })
                    .catch((err2) => {
                      if (err2.status === 404) {
                        context.commit('pushError', {
                          error: 'Ошибка!',
                          message: 'Вложение не найдено',
                        });
                      } else {
                        context.commit('pushError', {
                          error: 'Ошибка!',
                          message: 'Невозможно загрузить вложение',
                        });
                      }
                      console.log('11111111111');
                      reject(err2);
                    });
                } else {
                  context.dispatch('refreshUser')
                    .then(() => dataDB.getThumb(mediaId))
                    .then((blob) => {
                      resolve(blob);
                    })
                    .catch((err3) => {
                      console.log('STORE getThumb err3', err3);
                      if (err3.status === 404) {
                        context.commit('pushError', {
                          error: 'Ошибка!',
                          message: 'Вложение не найдено',
                        });
                      } else {
                        context.commit('pushError', {
                          error: 'Ошибка!',
                          message: 'Невозможно загрузить вложение',
                        });
                      }
                      console.log('22222222222222');
                      reject(err3);
                    });
                }
              });
          } else if (err.status === 404) {
            context.commit('pushError', {
              error: 'Ошибка!',
              message: 'Вложение не найдено',
            });
            reject(err);
          } else {
            context.commit('pushError', {
              error: 'Ошибка!',
              message: 'Невозможно загрузить вложение',
            });
            reject(err);
          }
        });
    });
  }, */
  /**
   * pleaseNumerate (context)
   */
  pleaseNumerate(context) {
    setTimeout(() => {
      context.dispatch('waitRefresh')
        .then(() => {
          fetch('/numerate', { headers: { authorization: context.state.user.access_token } });
        });
    }, 2000);
  },
  /**
   * pleaseThumbate (context)
   */
  pleaseThumbate(context) {
    setTimeout(() => {
      context.dispatch('waitRefresh')
        .then(() => {
          fetch('/thumbate', { headers: { authorization: context.state.user.access_token } });
        });
    }, 2000);
  },
  /**
   * notifyMaster (context, master)
   */
  notifyMaster(context, payload) {
    context.dispatch('waitRefresh')
      .then(() => {
        fetch('/master', {
          method: 'POST',
          body: JSON.stringify(payload),
          headers: { authorization: context.state.user.access_token },
        });
      });
  },
  /**
   * placeToBuffer (context, value)
   * value = {id:unit.id, parent_id:unit.parent_id}
   */
  placeToBuffer(context, value) {
    value.label = (value.id.indexOf('case:') === 0 ?
      `Кейс № ${context.state.cases[value.id].label}`
      :
      context.getters.formatUnit(value.id).label);
    context.commit('setBuffer', value);
    context.commit('pushError', {
      error: 'Подготовка к перемещению',
      message: `${value.label} теперь в буфере обмена`,
      type: 'positive',
    });
  },
  /**
   * placeFromBuffer (context, parentId)
   */
  placeFromBuffer(context, parentId) {
    return new Promise((resolve) => {
      const oldParent = context.getters.formatUnit(context.state.buffer.parent_id);
      const newParent = context.getters.formatUnit(parentId);

      Dialog.create({
        title: 'Подтвердите перемещение',
        'prevent-close': true,
        message: `${context.state.buffer.label} будет перемещен из ${oldParent.label} в ${newParent.label}`,
        ok: {
          flat: true,
          color: 'warning',
          label: 'Переместить',
        },
        cancel: {
          flat: true,
          color: 'info',
          label: 'Отмена',
        },
      })
        .then(() => {
          const i = context.state.buffer.id;
          const b = i[0] === 'c' ? context.state.cases[i] : context.state.units[i];
          const u = Vue.$copy(
            b,
            {
              parent_id: parentId,
              editedBy: context.state.user.roles[0],
              lastEdited: Date.now(),
            },
          );
          return dataDB.put(u);
        })
        .then(() => {
          context.commit('setBuffer', null);
          resolve(true);
        })
        .catch((err) => {
          if (err) console.log(err);
          if (err.status === 409) {
            context.commit('pushError', {
              error: 'Конфликт',
              message: 'Перемещение не выполнено',
              type: 'warning',
            });
          }
          context.commit('setBuffer', null);
          resolve(false);
        });
    });
  },

  /**
   * savePic (context, data)
   * save Picture after editing data: {id, file}
   */
  savePic(context, data) {
    console.log('STORE savePic', data);
    const updates = {
      editedBy: context.state.user.roles[0],
      lastEdited: Date.now(),
      saved: false, // not saved on server
      _attachments: {
        media: {
          content_type: data.file.type,
          data: data.file,
        },
      },
    };
    // seek in local database
    return dataDB.allDocs({
      include_docs: true,
      key: data.id,
    })
      .then((result) => {
        if (result.rows[0] && result.rows[0].doc) {
          const doc = result.rows[0].doc;
          console.log('from local doc', doc);
          Object.assign(doc, updates);
          return dataDB.put(doc);
        }
        throw new Error('not found');
      })
      .catch((err) => {
        if (err.message === 'not found') { // if not found in local let's seek in remote
          return utils.no401(
            dataDB,
            dataDB.allDocs,
            { include_docs: true, key: data.id },
            true,
          )
            .then((result) => {
              if (result.rows[0] && result.rows[0].doc) {
                const doc = result.rows[0].doc;
                console.log('from remote doc', doc);
                Object.assign(doc, updates);
                return dataDB.put(doc, { force: true }); // force put doc despite _rev conflict
                // into local db then will be replicated to remote
              }
              throw new ErrorExt(// not found anywhere
                'Файл не найден',
                {
                  error: 'Ошибка',
                  statusCode: 404,
                },
              );
            });
        }
        throw err;
      });
  },

  /**
   * saveUnit (context, data)
   */
  saveUnit(context, data) {
    console.log('STORE saveUnit', data);
    const _data = Object.assign({}, data, {
      editedBy: context.state.user.roles[0],
      lastEdited: Date.now(),
    });
    return new Promise((resolve, reject) => {
      // check _id and parent_id validity
      let ok = true;
      if (!_data._id) {
        ok = false;
      } else {
        // const c = _data._id.split(':')[0];
        const c = utils.getId(_data);
        if (!_data.parent_id) {
          ok = (c === 'req' || c === 'x'); // media or request don't have parent_id
        } else {
          // const p = _data.parent_id.split(':')[0];
          const p = utils.getId(_data.parent_id);
          switch (c) {
            case 'hosp':
              if (p !== 'root') {
                ok = false;
              }
              break;
            case 'div':
              if (p !== 'hosp') {
                ok = false;
              }
              break;
            case 'ins':
              if (p !== 'hosp' && p !== 'div') {
                ok = false;
              }
              break;
            case 'pers':
              if (p !== 'hosp' && p !== 'div') {
                ok = false;
              }
              break;
            case 'case':
              if (p !== 'ins') {
                ok = false;
              }
              break;
            default:
              ok = false;
          }
          if (_data.parent_id !== 'root' && !context.state.units[_data.parent_id]) {
            ok = false;
          }
        }
      }
      if (!ok) {
        context.commit('pushError', {
          error: 'Ошибка',
          message: 'Невалидные данные',
        });
        reject(new Error('Невалидные данные'));
        return;
      }
      dataDB.put(_data)
        .then(() => {
          resolve(true);
        })
        .catch((err) => {
          console.log('STORE saveUnit error', err);
          if (err.status !== 409) {
            context.commit('pushError', err);
          } else {
            context.commit('pushError', {
              error: 'Конфликт',
              message: 'Изменения не будут сохранены',
              type: 'warning',
            });
          }
          reject(err);
        });
    });
  },
  /**
   * deleteUnit (context, data)
   */
  deleteUnit(context, data) {
    return new Promise((resolve, reject) => {
      if (typeof (data) === 'string') { // id
        dataDB.get(data, (err, doc) => {
          if (err) {
            if (err.status === 404) {
              return resolve(false); // already deleted
            }
            reject(err);
          } else {
            resolve(context.dispatch('deleteUnit', doc));
          }
        });
      } else {
        dataDB.remove(data)
          .then(() => {
            resolve(true);
          })
          .catch((err) => {
            if (err.status === 404) {
              return resolve(false); // already deleted
            }
            if (err.status !== 409) {
              context.commit('pushError', err);
            } else {
              context.commit('pushError', {
                error: 'Конфликт',
                message: 'Удаление невозможно',
                type: 'warning',
              });
            }
            reject(err);
          });
      }
    });
  },
  /**
   * populateUnits(context)
   * initial populate units
   */
  populateUnits(context) {
    return new Promise((resolve, reject) => {
      dataDB.allDocs({
        include_docs: true,
        startkey: 'a', // to skip design,
        endkey: 'w', // to skip medias
      })
        .then((result) => {
          // console.log('STORE populateUnits', result.rows)
          context.commit('setUnits', result.rows.map(row => row.doc));
          resolve(true);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  /**
   * populateOffMedias(context)
   * initial populate offline medias
   */
  populateOffMedias(context) {
    return new Promise((resolve, reject) => {
      dataDB.allDocs({
        include_docs: true,
        startkey: 'x', // to include only medias,
      })
        .then((result) => {
          context.commit('setOffMedias', result.rows.map(row => row.doc));
          resolve(true);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  /**
   * populateParents(context)
   */
  populateParents(context) {
    console.log('populateParents');
    return new Promise((resolve, reject) => {
      /* eslint-disable */
      const designDoc = {
        _id: '_design/utils',
        views: {
          parents: {
            map: function (doc) {
              if (doc.parent_id) emit(doc.parent_id, doc._id);
            }.toString(),
            reduce: function (key, values) {
              return values.join(';');
            }.toString(),
          },
          names: {
            map: function (doc) {
              if (doc._id[0] === 'i') emit(doc.name, null);
            }.toString(),
            reduce: function (key, values) {
              return null;
            }.toString(),
          },
          cities: {
            map: function (doc) {
              if (doc.city) emit(doc.city, null);
            }.toString(),
            reduce: function (key, values) {
              return null;
            }.toString(),
          },
        },
      };
      /* eslint-enable */
      dataDB.put(designDoc, (err) => {
        if (err && err.name !== 'conflict') {
          reject(err);
        }
        dataDB.query('utils/parents', { group: true })
          .then((result) => {
            context.commit('setParents', result.rows);
            resolve(true);
          })
          .catch((err2) => {
            reject(err2);
          });
      });
    });
  },
  /**
   * setUserData (context, data)
   */
  setUserData(context, data) {
    console.log('setUserData data user', data, context.state.user.email);
    return new Promise((resolve, reject) => {
      context.dispatch('waitRefresh')
        .then(() => users.setData(context.state.user, data))
        .then(() => {
          context.commit('modifyUser', data);
          resolve(context.state.user);
        })
        .catch((err) => {
          console.log('setUserData ERROR', err);
          reject(err);
        });
    });
  },


  startLiveSync(context) {
    if (context.state.syncer && context.state.syncer.cancel) {
      context.state.syncer.cancel();
    }
    const liveSync = dataDB.sync({
      live: true,
      retry: false,
      pull: {// do not pull from server medias and design docs
        filter: 'validate/filter',
      },
      push: {// do not push to server design docs and deleted or already saved media
        filter(doc) {
          return !(doc._id[0] === '_' || (doc._id[0] === 'x' && (doc._deleted || doc.saved)));
        },
      },
    })
      .on('change', (info) => {
        console.log('LIVE change', info);
        context.commit('setSyncing', '');
      })
      .on('paused', () => {
        console.log('LIVE paused');
        context.dispatch('hideSyncing');
        context.dispatch('processMedias');
      })
      .on('active', (info) => {
        console.log('LIVE active', info);
        context.commit('setSyncing', info.direction);
      })
      .on('complete', (info) => {
        console.log('LIVE complete', info);
        context.dispatch('hideSyncing');
      })
      .on('denied', (err) => {
        console.log('LIVE denied', err);
        context.dispatch('hideSyncing');
        context.commit('pushError', {
          error: 'Рассинхронизация',
          message: `${err.doc.message} Данные будут перезагружены`,
          type: 'negative',
          callback() {
            context.dispatch('destroyDataDB')
              .then(() => {
                window.location = window.location;
              });
          },
        });
      })
      .on('error', (err) => {
        console.log('LIVE error', err);
        if (err.status === 401 && err.reason === 'Name or password is incorrect.') {
          context.dispatch('refreshUser') // liveSync error
            .then((user) => {
              console.log('refreshUser user', user);
              context.dispatch('startLiveSync');
            })
            .catch((err2) => {
              console.log('refreshUser error', err2);
              if (err2.statusCode === 401) {
                context.commit('setSyncing', '');
                router.push('/sign-in');
              } else {
                // after refreshUser error exept 401
                context.commit('setSyncing', 'suspended');
                setTimeout(() => {
                  context.dispatch('startLiveSync');
                }, 10000);
              }
            });
        } else if (err.status === 401 && err.reason === 'You are not authorized to access this db.') {
          context.commit('pushError', err);
          router.push('/sign-in?destroy=1');
        } else {
          // after LIVE error exept 401
          context.commit('setSyncing', 'suspended');
          setTimeout(() => {
            context.dispatch('startLiveSync');
          }, 10000);
        }
      });
    context.commit('setSyncer', liveSync);
  },

  /**
   * ENTRY POINT AFTER LOG IN
   * loadUserAndData (context, token)
   */

  loadUserAndData(context, token) {
    console.log('START loadUserAndData', token);
    const startPopulateAndTrack = () => new Promise((resolve, reject) => {
      context.dispatch('populateUnits')
        .then(() => context.dispatch('populateParents'))
        .then(() => context.dispatch('populateOffMedias'))
        .then(() => {
          console.log('endInitializing onComplete');
          context.commit('endInitializing');
          dataDB.trackChanges(doc => context.commit('handleChanges', doc));
          resolve(true);
        })
        .catch((err) => {
          reject(err);
        });
    });
    const startIniSync = () => new Promise((resolve, reject) => {
      dataDB.sync({
        pull: {// do not pull from server medias and design docs
          filter: 'validate/filter',
        },
        push: {// do not push to server design docs and deleted or already saved media
          filter(doc) {
            return !(doc._id[0] === '_' || (doc._id[0] === 'x' && (doc._deleted || doc.saved)));
          },
        },
      })
        .on('change', (info) => {
          console.log('INIT change', info);
        })
        .on('paused', (info) => {
          console.log('INIT paused', info);
          context.dispatch('hideSyncing');
        })
        .on('active', (info) => {
          console.log('INIT active', info);
          context.commit('setSyncing', info.direction);
        })
        .on('complete', (info) => {
          console.log('INIT complete', info);
          context.dispatch('hideSyncing');
          startPopulateAndTrack()
            .then(() => {
              context.dispatch('startLiveSync');
              resolve('onComplete');
            })
            .catch((err) => {
              console.log('endInitializing catch Error');
              context.commit('endInitializing');
              // context.commit('pushError', err);
              reject(err);
            });
        })
        .on('denied', (err) => {
          console.log('INIT denied', err);
          context.dispatch('hideSyncing');
          context.commit('pushError', {
            error: 'Рассинхронизация',
            message: `${err.doc.message} Данные будут перезагружены`,
            type: 'negative',
            callback() {
              context.dispatch('destroyDataDB')
                .then(() => { // reload page
                  window.location = window.location;
                });
            },
          });
        })
        .on('error', (err) => {
          console.log('INIT sync error', err);
          context.dispatch('hideSyncing');
          if (err.status === 401 && err.reason === 'You are not authorized to access this db.') {
            router.push('/sign-in?destroy=1');
          } else {
            console.log('INIT sync error -- start LIVE sync');
            (() => {
              if (err.status === 401) {
                console.log('INIT sync error 401 -- refreshUser');
                return context.dispatch('refreshUser'); // INIT sync error
              }
              return Promise.resolve(true);
            })()
              .then(() => startPopulateAndTrack())
              .then(() => {
                context.dispatch('startLiveSync');
                resolve('onError');
              })
              .catch((err2) => {
                console.log('endInitializing onError');
                context.commit('endInitializing');
                // context.commit('pushError', err2);
                reject(err2);
              });
          }
        });
    });
    const loadStoredUser = (tkn) => {
      console.log('START loadStoredUser', tkn);
      return new Promise((resolve, reject) => {
        if (localStorage.getItem('user')) {
          console.log('FOUND loadStoredUser', tkn);
          const storedUser = JSON.parse(localStorage.getItem('user'));
          if ((storedUser.access_token === tkn) &&
            storedUser.screenname && typeof (storedUser.screenname) === 'string' &&
            storedUser.roles && storedUser.roles[0] && typeof (storedUser.roles[0]) === 'string' &&
            storedUser.password && typeof (storedUser.password) === 'string' &&
            storedUser.email && typeof (storedUser.email) === 'string' &&
            storedUser.db && typeof (storedUser.db) === 'string'
          ) {
            console.log('CHEKED loadStoredUser', tkn);
            resolve(storedUser);
            return;
          }
        }
        console.log('NO loadStoredUser', tkn);
        reject(tkn);
      });
    };
    if (context.state.syncer && context.state.syncer.cancel) {
      context.state.syncer.cancel();
    }
    context.commit('setSyncer', null);
    let isStoredUser = false;
    return new Promise((resolve, reject) => {
      loadStoredUser(token)
        .then((user) => {
          console.log('LOADED StoredUser', user);
          isStoredUser = true;
          return user;
        })
        .catch((tkn) => {
          console.log('NO StoredUser', tkn);
          return users.getUser(tkn);
        })
        .then((user) => {
          context.commit('modifyUser', user);
          const pouchOpts = {
            skip_setup: true,
            ajax: {
              cache: true,
              timeout: 30000,
              /* headers: {
               'Cache-Control': 'max-age=10'
               } */
            },
            auth: {
              username: user.email,
              password: user.password,
            },
          };
          if (!user.db) {
            throw (new Error('Не задана база данных'));
          } else if (user.db === 'demo') {
            context.commit('pushError', {
              error: 'Тест-драйв',
              message: 'Вы подключены к тестовой базе данных',
              type: 'warning',
            });
          }
          const couchdburl = process.env.PROD ? 'https://polymed.vapania.com:6984/' : 'http://localhost:5984/';

          dataDB = new DataDB(user.db, { auto_compaction: true }, couchdburl + user.db, pouchOpts);
          Vue.prototype.$dataDB = dataDB;
          return dataDB.info();
        })
        .then((result) => {
          console.log('dataDB.info()', result);
          if (!isStoredUser) {
            console.log('No stored user');
            startIniSync()
              .then((res) => {
                resolve(res);
              })
              .catch((err) => {
                // context.commit('pushError', err);
                reject(err);
              });
          } else if (result.doc_count < 1) {
            console.log('ERROR isStoredUser but No DB');
            // router.push('/sign-in?destroy=1');
            reject(new ErrorExt(
              'Пустая локальная база данных',
              {
                error: 'Нет данных',
                statusCode: 404,
              },
            ));
          } else {
            let offline = false;
            Notify.create({
              message: 'Автономный режим',
              detail: 'У вас одна секунда',
              position: 'center',
              type: 'warning',
              icon: 'cloud_off',
              timeout: 1000,
              onDismiss() {
                if (offline) {
                  console.log('local mode ==========================================');
                  context.commit('setSyncing', 'off');
                  console.log('endInitializing offline');
                  context.commit('endInitializing');
                  startPopulateAndTrack()
                    .then((res) => {
                      resolve(res);
                    })
                    .catch((err) => {
                      // context.commit('pushError', err);
                      reject(err);
                    });
                } else {
                  console.log('INIT sync start1');
                  startIniSync()
                    .then((res) => {
                      resolve(res);
                    })
                    .catch((err) => {
                      // context.commit('pushError', err);
                      reject(err);
                    });
                }
              },
              actions: [
                {
                  label: 'Включить!',
                  handler: () => {
                    offline = true;
                  },
                },
              ],
            });
          }
        })
        .catch((err) => {
          console.log('ERROR!!!!', err);
          /* if (err.statusCode === 401) {
            router.push('/sign-in');
          } else {
            router.push('/sign-in?destroy=1');
          }
          context.commit('pushError', err); */
          reject(err);
        });
    });
  },
  /*
  handle401(context) {
    return new Promise((resolve, reject) => {

    });
  }, */
  waitRefresh(context) {
    console.log('***********waitRefresh***************');
    return new Promise((resolve) => {
      if (!context.state.refreshing) {
        console.log('*********** Not refreshing ***************');
        resolve(false);
      } else {
        const timer = setInterval(() => {
          console.log('--------------- Check --------------------');
          if (!context.state.refreshing) {
            clearInterval(timer);
            console.log('*********** Done ***************');
            resolve(true);
          }
        }, 1000);
      }
    });
  },
  refreshUser(context) { // refresh user and set refreshed password to coachDB
    context.commit('setRefreshing', true);
    return new Promise((resolve, reject) => {
      const accessToken = context.state.user.access_token;
      console.log('*****************START refreshUser accessToken=', accessToken);
      users.getUser(accessToken)
        .then((user) => {
          const str = `${user.email}:${user.password}`;
          dataDB.setToken(window.btoa(decodeURIComponent(encodeURIComponent(str))));
          context.commit('modifyUser', user);
          context.commit('setRefreshing', false);
          resolve(user);
        })
        .catch((err) => {
          console.log('refreshUser ERROR', err);
          context.commit('setRefreshing', false);
          reject(err);
        });
    });
  },
  loadMedias(context, key) {
    console.log('loadMedias access_token', context.state.user.access_token);
    return new Promise((resolve, reject) => {
      const query = key ? `?key=${key}` : '';
      context.dispatch('waitRefresh')
        .then(() => fetch(`/loadmedias${query}`, {
          method: 'GET',
          headers: { authorization: context.state.user.access_token },
        }))
        .then(res => res.json())
        .then((res) => {
          if (res.error) {
            console.log('loadMedias result error', res.error);
            reject(res);
          } else {
            resolve(res);
          }
        })
        .catch((err) => {
          console.log('loadMedias error', err);
          reject(err);
        });
    });
  },
  deleteFile(context, id) {
    return new Promise((resolve, reject) => {
      context.dispatch('waitRefresh')
        .then(() => fetch('/deletefile', {
          method: 'POST',
          body: JSON.stringify({ id }),
          headers: { authorization: context.state.user.access_token },
        }))
        .then(res => res.json())
        .then((res) => {
          console.log('deletefile res', res);
          if (res.error) {
            reject(res);
          } else {
            resolve(res);
          }
        })
        .catch((err) => {
          console.log('deletefile err', err);
          reject(err);
        });
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/actions.js